import { IStoryletState } from 'types/storylet';

export default function chooseBranchSuccess(state: IStoryletState, action: any): IStoryletState {
  const {
    canChangeOutfit,
    eligibleFriends,
    endStorylet,
    externalSocialAct,
    messages,
    phase,
    rename,
    secondChance,
    socialAct,
    storylet,
    storylets,
  } = action.payload;
  return {
    ...state,
    canChangeOutfit,
    eligibleFriends,
    endStorylet,
    storylets,
    phase,
    messages,
    rename,
    socialAct,
    externalSocialAct,
    secondChance,
    addedFriendId: 0,
    isChoosing: false,
    message: null,
    storylet: storylet || state.storylet,
  };
}